import { NOTIFICATION_MESSAGE, NotificationEntity, NotificationEvent } from '@msdk/common'
import { ToastNotification } from '@msdk/ui'
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

import { NotificationMarkdown } from '../../components/NotificationMessageRenderer/NotificationMarkdown'

interface NotificationState {
  nf: NotificationEntity[]
}

const INITIAL_STATE: NotificationState = {
  nf: [],
}

const notificationCtx = createContext<NotificationState>(INITIAL_STATE)
notificationCtx.displayName = 'NOTIFICATION_CTX'

export const useNotificationCtx = () => useContext(notificationCtx)

export const NotificationContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [nf, setNf] = useState<NotificationEntity[]>([])

  const context: NotificationState = useMemo(() => {
    return { nf }
  }, [nf])

  const removeNotificationFromList = (id: string | undefined) => {
    if (!id) {
      return
    }

    setNf((old) => {
      return old.filter((n) => n.id !== id)
    })
  }

  useEffect(() => {
    try {
      window?.addEventListener(NOTIFICATION_MESSAGE, (e: NotificationEvent) => {
        setNf((old) => {
          return [...old, e.inner as NotificationEntity]
        })
      })
    } catch (error) {
      throw new Error('💥 notification addEventListener', { cause: error })
    }
    return () => {
      window?.removeAllListeners?.(NOTIFICATION_MESSAGE)
    }
  }, [])

  return (
    <notificationCtx.Provider value={context}>
      {children}
      {nf.map((m) => {
        return (
          <ToastNotification
            key={m.id}
            open={true}
            title={m.title}
            time={m.time}
            message={m.message}
            severity={m.status ?? 'info'}
            waitUserAck={m.waitUserAck}
            closeOnClick={m.closeOnClick}
            onClose={() => removeNotificationFromList(m.id)}
            customMessageRenderer={
              typeof m.message === 'string' ? <NotificationMarkdown body={m.message} /> : undefined
            }
          ></ToastNotification>
        )
      })}
    </notificationCtx.Provider>
  )
}
